import { Component, OnInit, ViewEncapsulation,ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, DataStateChangeEvent,PageChangeEvent,RowClassArgs } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { timer as observableTimer, Subscription, Subject, Observable } from 'rxjs';
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime';
import { RvService,UserProfileService,RIAHelper,environment,DownloadService,DefaultsService,GDSCodeService } from '../../../core';
import { ConfigurableLinkListComponent } from '../../../common/component/configurable_link_list/configurable_link_list.component';
import { ActivatedRoute } from '@angular/router';
import { CustomReport } from '../../../core/models/CustomReport-model'
import { IdleTimeoutService } from '../../../core/idle-timeout.service';

import { AlertComponent, EnumAlertType } from '../../../common/component/alert/alert.component';
import { ConfirmDialogComponent } from '../../../common/component/confirm-dialog/confirm-dialog.component';



@Component({
  selector: 'rv-report',
  templateUrl: './rv-report.component.html',
  styleUrls: ['./rv-report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RvReportComponent implements OnInit {

  constructor(
   private defaultsService:DefaultsService
   ,private route: ActivatedRoute
   ,private gdsCodeService: GDSCodeService
   ,private rvService: RvService
   ,private downloadService: DownloadService
   ,private idleTimeoutSvc: IdleTimeoutService
   ) { }
  @ViewChild(AlertComponent, { static: true }) alertController: AlertComponent;
  @ViewChild(ConfirmDialogComponent, { static: true }) confirmDialog: ConfirmDialogComponent
  fieldList:string[] = ['GDS','Hotel Name','Address','City',
  'State / Province','Postal Code','Country Code','Chain Code',
  'Property Code','Rate Access Code','Currency Code','Season 1',
  'Season 1 Expected Price','Season 2',
  'Season 2 Expected Price','Season 3',
  'Season 3 Expected Price','Season 4',
  'Season 4 Expected Price','Season 5',
  'Season 5 Expected Price','Season 6',
  'Season 6 Expected Price'];
  disableRequests:boolean = false;
  longRunningRAWMessage:string="";
  currentReport:string=null;

  showModal:boolean = false;
  auditId:string;
  scheduleId:string;
  activeTab:string;
  linkList:GridDataResult;
  gdsCodeList:Array<{text:string, value:number}> = [];
  currentAuditId:string;
  currentScheduleId:string;
  selectedReportConfig:{
    outputFieldCustomizationData:{
      [key:string]:any
    },
    gds:{text:string,value:number},
    [key:string]:any
  };
  availableReportConfigurations:[{
    outputFieldCustomizationData:object,
    gds:{text:string,value:number},
    [key:string]:any
  }];
  public state: State = {
    filter:undefined,
    skip: 0,
    take: 5,
    group:[],
    sort:[{dir:"asc",field:"Name"}]
  };
  public norecords:boolean=true;
  public ReportID:string;
  reportData: GridDataResult;
  numSelectedDatesArray: Array<any>;
  public AuditPropertyIDList:string;
  public isNewReport:boolean=true;

  public CustomReportObj: CustomReport = {
    ReportID:"",
    AuditID:"",
    AuditScheduleID:"",
    PropertyList:"",
    GDS:"",
    Description:"",
    Wrd_ReportTitle:"",

    Wrd_GDS:"",
    Wrd_HotelName:"",
    Wrd_Address:"",
    Wrd_City:"",
    Wrd_StateProvince:"",
    Wrd_PostalCode:"",
    Wrd_CountryCode:"",
    Wrd_ChainCode:"",
    Wrd_PropCode:"",
    Wrd_RateAccessCode:"",
    Wrd_CurrencyCode:"",
    Wrd_Season1:"",
    Wrd_Season2:"",
    Wrd_Season3:"",
    Wrd_Season4:"",
    Wrd_Season5:"",
    Wrd_Season6:"",
    Wrd_Season1ExpectedPrice:"",
    Wrd_Season2ExpectedPrice:"",
    Wrd_Season3ExpectedPrice:"",
    Wrd_Season4ExpectedPrice:"",
    Wrd_Season5ExpectedPrice:"",
    Wrd_Season6ExpectedPrice:"",

    HideGDS:"",
    HideHotelName:"",
    HideAddress:"",
    HideCity:"",
    HideStateProvince:"",
    HidePostalCode:"",
    HideCountry:"",
    HideChainCode:"",
    HidePropCode:"",
    HideRateAccessCode:"",
    HideCurrencyCode:"",
    HideSeason1:"",
    HideSeason1ExpectedPrice:"",
    HideSeason2:"",
    HideSeason2ExpectedPrice:"",
    HideSeason3:"",
    HideSeason3ExpectedPrice:"",
    HideSeason4:"",
    HideSeason4ExpectedPrice:"",
    HideSeason5:"",
    HideSeason5ExpectedPrice:"",
    HideSeason6:"",
    HideSeason6ExpectedPrice:"",

    Wrd_Available:"",
    Wrd_AvailableHigher:"",
    Wrd_AvailableLower:"",
    Wrd_RateNotAvailable:"",
    Wrd_HotelNotAvailable:"",
    Wrd_AvailableABR:"",
    Wrd_AvailableHigherABR:"",
    Wrd_AvailableLowerABR:"",
    Wrd_RateNotAvailableABR:"",
    Wrd_HotelNotAvailableABR:"",
  }

  setSeasonDisplayDates(config, seasonNumber:number) {
    if(config['Season' + seasonNumber + 'StartDate'] &&
        config['Season' + seasonNumber + 'EndDate']) {
      let startDate:Date = new Date(config['Season' + seasonNumber + 'StartDate']);
      let endDate = new Date(config['Season' + seasonNumber + 'EndDate']);
      config['Season' + seasonNumber + 'StartDateDisplay'] = (startDate.getMonth()+1) + '/' + startDate.getDate() + '/' + startDate.getFullYear();
      config['Season' + seasonNumber + 'StartDateDisplay'] += ' - ' + (endDate.getMonth()+1) + '/' + endDate.getDate() + '/' + endDate.getFullYear();
    } else {
      config['Season' + seasonNumber + 'StartDateDisplay'] = '';
    }
  }

  ngOnInit() {
    this.auditId = this.route.snapshot.params.auditId;
    this.scheduleId = this.route.snapshot.params.scheduleId;

    this.activeTab = 'RateAvailabilityReports';
    this.currentAuditId = this.route.snapshot.params.auditId;
    this.currentScheduleId = this.route.snapshot.params.scheduleId;
    let serverGDSCodeList;
    //get the gds code list if we haven't gotten it yet
    this.gdsCodeService.storeGDSCodeList(this.currentAuditId, this.currentScheduleId);
    this.gdsCodeService.getGDSCodeList(list => {
      serverGDSCodeList = list;
      this.gdsCodeList = this.defaultsService.GetGDSCodes(serverGDSCodeList);
      if(this.selectedReportConfig) {
        console.log('Setting selecting report config gds to:' + this.gdsCodeList[0].text);
        this.selectedReportConfig.gds = this.gdsCodeList[0];
      } else {
        console.log('Cannot set GDS, no report is selected.')
      }
    });

    this.linkList = {data:[{
      title:'Export Standard Combined GDS Report',
      href:'#',
      routerLink:false,
      paramObject:{},
      param:'ERTME'
    },{
      title:'Load On-Screen Interactive Report',
      href:'../interactive-report',
      routerLink:true,
      paramObject:{
        auditId:this.route.snapshot.params.auditId,
        scheduleId:this.route.snapshot.params.scheduleId
      },
      param:''
    },{
      title:'Export RAW Row Based Report',
      href:'#',
      routerLink:false,
      paramObject:{},
      param:'ERRBRTME'
    },{
      title:'Export RAW Column Based Report',
      href:'#',
      routerLink:false,
      paramObject:{},
      param:'ERCBRTME'
    },{
      title:'Export Negotiated/Retail/BAR RAW Report',
      href:'#',
      routerLink:false,
      paramObject:{},
      param:'ENRBRR'
    }], total:5};

    this.LoadPageDetails();
    this.gdsCodeService.getGDSCodeList(list=>{
      this.createNewReportConfiguration();
    });
  };

  changeGDSCode() {
    let t1 = this;
    this.rvService
        .getCustomReportData(this.auditId, this.scheduleId,
          this.selectedReportConfig.gds.text)
        .subscribe(function(response) {

      let responseObject = response.json();
      let list:[{
        [key:string]:any
      }] = responseObject;

      //do transformation on the date values
      for(let ctr=0; ctr<list.length; ctr++) {
        let row:{
          [key:string]:any
        } = list[ctr];
        t1.setSeasonDisplayDates(row, 1);
        t1.setSeasonDisplayDates(row, 2);
        t1.setSeasonDisplayDates(row, 3);
        t1.setSeasonDisplayDates(row, 4);
        t1.setSeasonDisplayDates(row, 5);
        t1.setSeasonDisplayDates(row, 6);
      }
      //t1.numSelectedDates = list[0].DetailReportDateDataList.length;
      t1.numSelectedDatesArray = [];
      t1.reportData = {
        data:list,
        total:list.length
      };

      //iterate through DetailDateDataList and put them onto list as direct properties
      for(let ctr=0; ctr<list.length; ctr++) {
        let row = list[ctr];
        for(let ctr1=0; ctr1<row.DetailReportDateDataList.length; ctr1++) {
          let dateData = row.DetailReportDateDataList[ctr1];
          if(ctr==0) {
            t1.numSelectedDatesArray.push(dateData);
          }
          row['SelectedDateDisplay' + ctr1 + 'ExpectedPrice'] = dateData.ExpectedPrice;
          row['SelectedDateDisplay' + ctr1 + 'Title'] = dateData.SelectedDate;
          row['SelectedDateDisplay' + ctr1 + 'Status'] = dateData.Status;
        }
      }
    });
  }

  switchTab($event){
    $event.preventDefault();
    var targetLi = $event.target.parentElement;
    var tab = targetLi.id;
    if(tab){
      this.activeTab = tab.replace('ListItem', '');
    }
  };

  changeSelectedReportConfig($event) {
    var reportConfig = $event.item;
    if(reportConfig) {
      this.isNewReport = false;
      this.selectedReportConfig = reportConfig;
      this.changeGDSCode();
    } else {
      console.log('No item in click event');
    }
  };

  deleteReportConfiguration($event) {
    let t = this;
    var item = $event.item;
    t.showModal = true;
    t.confirmDialog.confirm("Are you sure you want to delete this template?"
    , "", "Delete Template")
    .subscribe(ok => {
      if (ok) {
        var index = t.availableReportConfigurations.indexOf(item);
        if(index>-1) {
          t.saveDataToClassObject(item, 'delete');

          t.rvService.DeleteCustomReport(t.CustomReportObj)
          .subscribe(data=>{
            if(data.success) {
              t.availableReportConfigurations.splice(index, 1);
            } else {
              this.alertController.showAlertMessage(5000,"Problem when deleting:" + data.message,EnumAlertType.Error);
            }

          },
          (err)=> {
            console.log(err);
          });
        } else {
          console.log('Index not found in delete method');
        }
        if(item==t.selectedReportConfig) {
          this.createNewReportConfiguration();
        }
      }
    }, (err) => {
      console.log(err);
    });

  };

  toggleCheckbox(dataItem) {
    dataItem.active = !dataItem.active;
  };

  createNewReportConfiguration() {
    this.isNewReport=true;
    let defaultOutputFieldCustomizationDataList = [];
    for(let ctr=0; this.fieldList && ctr<this.fieldList.length; ctr++) {
      let javascriptId = this.defaultsService.GetJavascriptIdFromFieldName(this.fieldList[ctr]);

      defaultOutputFieldCustomizationDataList[ctr] = {
        active: true,
        id: this.fieldList[ctr],
        javascriptId: javascriptId,
        override: this.fieldList[ctr]
      };
    }
    //default selected gds code should be first in the list
    let defaultGDSCode = 'Default';
    if(this.gdsCodeList && this.gdsCodeList.length>0){
      defaultGDSCode = this.gdsCodeList[0].text;
      console.log('Selecting default GDS code:' + defaultGDSCode);
    }
    this.selectedReportConfig = {
      id:0,
      textContent:'',
      isDefault: false,
      gds: {
        text: defaultGDSCode,
        value: 0
      },
      outputFieldCustomizationData:{
        data: defaultOutputFieldCustomizationDataList,
        total:defaultOutputFieldCustomizationDataList.length
      },
      reportTitleSettings:{
        data:[{
          id:'Available',
          override:'Available',
          overrideAbr:'AVL'
        },{
          id:'Available Higher',
          override:'Available Higher',
          overrideAbr:'AH'
        },{
          id:'Available Lower',
          override:'Available Lower',
          overrideAbr:'AL'
        },{
          id:'Rate Not Available',
          override:'Rate Not Available',
          overrideAbr:'RNA'
        },{
          id:'Hotel Not Available',
          override:'Hotel Not Available',
          overrideAbr:'HNA'
        }],
        total:5
      }
    };

    let selectDiv: Element = document.getElementsByClassName('reportConfigurationList')[0];
    if(selectDiv) {
      var optionArray:HTMLCollectionOf<HTMLOptionElement> = selectDiv.getElementsByTagName('option');
      if(optionArray) {
        for(let ctr = 0; ctr<optionArray.length; ctr++) {
          var option:HTMLOptionElement = optionArray[ctr];
          option.selected = false;
        }
      }
    }
  }

  DownloadRVReports(ReportType){
    this.currentReport = ReportType;
    this.updateReportMsg("Requesting report...");
    this.disableRequests = true;
    if(ReportType==='ERTME'){
      this.downloadService.downloadInteractiveReportToExcel(this.auditId,this.scheduleId,()=>this.EndReport())
        .subscribe((data)=>{},
        (err)=> {
          console.log(err);
          this.ReportFailed();
        })
    } else if(ReportType==='ERRBRTME') {
      this.downloadService.downloadRAWReport(this.auditId,this.scheduleId,"RA_RAWROW",()=>this.EndReport())
      .subscribe((data)=>{},
      (err)=> {
        console.log(err);
        this.ReportFailed();
      })
    }
    else if(ReportType==='ERCBRTME'){
      this.downloadService.downloadRAWReport(this.auditId,this.scheduleId,"RA_RAWCOL",()=>this.EndReport())
      .subscribe((data)=>{},
      (err)=> {
        console.log(err);
        this.ReportFailed();
      })
    }
    else if(ReportType==='ENRBRR'){
      this.disableRequests = true;
      this.updateReportMsg("Requesting report...");
      this.downloadService.downloadRAReport(this.auditId,this.scheduleId,"RA_RAWBAR")
      .subscribe( rsp => {
        rsp.subscribe(delayedID => {
          this.updateReportMsg("Waiting for report...");
          let timerSub = observableTimer(5000,5000).subscribe(
            (n) => {
              console.log("call ReportStatusUpdate "+ n);
              this.idleTimeoutSvc.resetTimer();
              this.downloadService.downloadReportStatusUpdate(delayedID)
              .subscribe((ready)=>{
                console.log(ready  + ' ' + delayedID);
                if(ready){
                  timerSub.unsubscribe();
                  this.disableRequests = true;
                  if(ready == true){
                    this.downloadService.downloadReportComplete(delayedID);
                    this.EndReport();
                  }else{
                    this.ReportFailed();
                  }
                }else{
                  console.log(n);
                  this.updateReportMsg("Continuing to wait for report (up to 30 minutes)..."+ ".".repeat(n%10));
                  if(n>365){ //=5 + 30*60/5
                    timerSub.unsubscribe();
                    this.disableRequests = false;
                    this.updateReportMsg("Timeout waiting for report.");//SSRS should timeout 5 seconds before this
                  }
                }
              },
            (err)=> {
              timerSub.unsubscribe();
              this.ReportFailed();
            });
            }
          );
        },
        (err)=> {
          console.log(err);
          this.ReportFailed();
        });
      },
      (err)=> {
        console.log(err);
        this.ReportFailed();
      });
    }
    else{
      this.EndReport();
    }
  }
  ReportFailed(){
    this.disableRequests=false;
    this.updateReportMsg("Request failed");
  }
  updateReportMsg(msg: string): void{
    this.longRunningRAWMessage = msg;
  }
  EndReport(){
    this.disableRequests=false;
    this.longRunningRAWMessage=null;
    this.currentReport = null;
  }

  ExportToExcel() {
    if(!this.selectedReportConfig.textContent || !this.selectedReportConfig.Description) {
      this.alertController.showAlertMessage(5000,"Report name and description required",EnumAlertType.Error);
    } else {
      //use the currently selectd report configuration for exporting
      this.saveDataToClassObject(false, 'export');

      this.downloadService.downloadCustomReport(this.CustomReportObj)
      .subscribe((data)=>{},
        (err)=> {
          console.log(err);
        }
      );
    }
  }

  saveReport() {
    if(!this.selectedReportConfig.textContent || !this.selectedReportConfig.Description){
      this.alertController.showAlertMessage(5000,"Please enter title and description",EnumAlertType.Error);
    } else {
      //save the currently selected custom report template
      this.saveDataToClassObject(false, 'save');
      this.rvService.SaveCustomReport(this.CustomReportObj)
      .subscribe((data)=>{
        if(data.success) {
          //if this is a new report that was just saved, remember the report ID
          if(!this.selectedReportConfig.ReportID) {
            if(data.optionalParameters && data.optionalParameters[0]) {
              this.selectedReportConfig.ReportID = data.optionalParameters[0];
            } else {
              console.log('New report, but no ID was passed back');
            }
          }
          this.isNewReport=false;
          this.LoadPageDetails();
          this.alertController.showAlertMessage(5000,"Report saved succesfully",EnumAlertType.Success);
        } else {
          this.alertController.showAlertMessage(5000,"Problem when saving report:" + data.message,EnumAlertType.Error);
        }

      },
      (err)=> {
        this.alertController.showAlertMessage(5000,"Error in saving the report",EnumAlertType.Error);
      });
    }
  }

  saveDataToClassObject(obj:any, method:string){
    if(!obj) {
      obj = this.selectedReportConfig;
    }
    if(this.reportData) {
      if(this.reportData.data) {
        this.reportData.data.forEach(data => {
          this.AuditPropertyIDList+=  "|"+data.AuditPropertyID;
        });
      }
    } else {
      console.log('ReportData does not exist');
    }

    this.CustomReportObj.ReportID=obj.ReportID;
    this.CustomReportObj.AuditID=this.auditId;
    this.CustomReportObj.AuditScheduleID=this.scheduleId;
    if(this.AuditPropertyIDList) {
      this.CustomReportObj.PropertyList=this.AuditPropertyIDList.substring(9);
    } else {
      this.CustomReportObj.PropertyList='';
    }
    this.CustomReportObj.Description=obj.Description;
    this.CustomReportObj.GDS = obj.gds.text;
    this.CustomReportObj.Wrd_ReportTitle=obj.textContent;

    this.CustomReportObj.Wrd_GDS=obj.outputFieldCustomizationData.data[0].override;
    this.CustomReportObj.Wrd_HotelName=obj.outputFieldCustomizationData.data[1].override;
    this.CustomReportObj.Wrd_Address=obj.outputFieldCustomizationData.data[2].override;
    this.CustomReportObj.Wrd_City=obj.outputFieldCustomizationData.data[3].override;
    this.CustomReportObj.Wrd_StateProvince=obj.outputFieldCustomizationData.data[4].override;
    this.CustomReportObj.Wrd_PostalCode=obj.outputFieldCustomizationData.data[5].override;
    this.CustomReportObj.Wrd_CountryCode=obj.outputFieldCustomizationData.data[6].override;
    this.CustomReportObj.Wrd_ChainCode=obj.outputFieldCustomizationData.data[7].override;
    this.CustomReportObj.Wrd_PropCode=obj.outputFieldCustomizationData.data[8].override;
    this.CustomReportObj.Wrd_RateAccessCode=obj.outputFieldCustomizationData.data[9].override;
    this.CustomReportObj.Wrd_CurrencyCode=obj.outputFieldCustomizationData.data[10].override;
    this.CustomReportObj.Wrd_Season1=obj.outputFieldCustomizationData.data[11].override;
    this.CustomReportObj.Wrd_Season2=obj.outputFieldCustomizationData.data[13].override;
    this.CustomReportObj.Wrd_Season3=obj.outputFieldCustomizationData.data[15].override;
    this.CustomReportObj.Wrd_Season4=obj.outputFieldCustomizationData.data[17].override;
    this.CustomReportObj.Wrd_Season5=obj.outputFieldCustomizationData.data[19].override;
    this.CustomReportObj.Wrd_Season6=obj.outputFieldCustomizationData.data[21].override;
    this.CustomReportObj.Wrd_Season1ExpectedPrice=obj.outputFieldCustomizationData.data[12].override;
    this.CustomReportObj.Wrd_Season2ExpectedPrice=obj.outputFieldCustomizationData.data[14].override;
    this.CustomReportObj.Wrd_Season3ExpectedPrice=obj.outputFieldCustomizationData.data[16].override;
    this.CustomReportObj.Wrd_Season4ExpectedPrice=obj.outputFieldCustomizationData.data[18].override;
    this.CustomReportObj.Wrd_Season5ExpectedPrice=obj.outputFieldCustomizationData.data[20].override;
    this.CustomReportObj.Wrd_Season6ExpectedPrice=obj.outputFieldCustomizationData.data[22].override;

    this.CustomReportObj.HideGDS=(!obj.outputFieldCustomizationData.data[0].active).toString();
    this.CustomReportObj.HideHotelName=(!obj.outputFieldCustomizationData.data[1].active).toString();
    this.CustomReportObj.HideAddress=(!obj.outputFieldCustomizationData.data[2].active).toString();
    this.CustomReportObj.HideCity=(!obj.outputFieldCustomizationData.data[3].active).toString();
    this.CustomReportObj.HideStateProvince=(!obj.outputFieldCustomizationData.data[4].active).toString();
    this.CustomReportObj.HidePostalCode=(!obj.outputFieldCustomizationData.data[5].active).toString();
    this.CustomReportObj.HideCountry=(!obj.outputFieldCustomizationData.data[6].active).toString();
    this.CustomReportObj.HideChainCode=(!obj.outputFieldCustomizationData.data[7].active).toString();
    this.CustomReportObj.HidePropCode=(!obj.outputFieldCustomizationData.data[8].active).toString();
    this.CustomReportObj.HideRateAccessCode=(!obj.outputFieldCustomizationData.data[9].active).toString();
    this.CustomReportObj.HideCurrencyCode=(!obj.outputFieldCustomizationData.data[10].active).toString();

    this.CustomReportObj.HideSeason1=(!obj.outputFieldCustomizationData.data[11].active).toString();
    this.CustomReportObj.HideSeason1ExpectedPrice=(!obj.outputFieldCustomizationData.data[12].active).toString();
    this.CustomReportObj.HideSeason2=(!obj.outputFieldCustomizationData.data[13].active).toString();
    this.CustomReportObj.HideSeason2ExpectedPrice=(!obj.outputFieldCustomizationData.data[14].active).toString();
    this.CustomReportObj.HideSeason3=(!obj.outputFieldCustomizationData.data[15].active).toString();
    this.CustomReportObj.HideSeason3ExpectedPrice=(!obj.outputFieldCustomizationData.data[16].active).toString();
    this.CustomReportObj.HideSeason4=(!obj.outputFieldCustomizationData.data[17].active).toString();
    this.CustomReportObj.HideSeason4ExpectedPrice=(!obj.outputFieldCustomizationData.data[18].active).toString();
    this.CustomReportObj.HideSeason5=(!obj.outputFieldCustomizationData.data[19].active).toString();
    this.CustomReportObj.HideSeason5ExpectedPrice=(!obj.outputFieldCustomizationData.data[20].active).toString();
    this.CustomReportObj.HideSeason6=(!obj.outputFieldCustomizationData.data[21].active).toString();
    this.CustomReportObj.HideSeason6ExpectedPrice=(!obj.outputFieldCustomizationData.data[22].active).toString();

    //if this is a new report that was just recently saved, data structure will be like a new report
    if(method!='delete' && (this.isNewReport || !obj.reportTitleSettings[0])) {
      this.CustomReportObj.Wrd_Available=obj.reportTitleSettings.data[0].override;
      this.CustomReportObj.Wrd_AvailableHigher=obj.reportTitleSettings.data[1].override;
      this.CustomReportObj.Wrd_AvailableLower=obj.reportTitleSettings.data[2].override;
      this.CustomReportObj.Wrd_RateNotAvailable=obj.reportTitleSettings.data[3].override;
      this.CustomReportObj.Wrd_HotelNotAvailable=obj.reportTitleSettings.data[4].override;
      this.CustomReportObj.Wrd_AvailableABR=obj.reportTitleSettings.data[0].overrideAbr;
      this.CustomReportObj.Wrd_AvailableHigherABR=obj.reportTitleSettings.data[1].overrideAbr;
      this.CustomReportObj.Wrd_AvailableLowerABR=obj.reportTitleSettings.data[2].overrideAbr;
      this.CustomReportObj.Wrd_RateNotAvailableABR=obj.reportTitleSettings.data[3].overrideAbr;
      this.CustomReportObj.Wrd_HotelNotAvailableABR=obj.reportTitleSettings.data[4].overrideAbr;
    } else {
      this.CustomReportObj.Wrd_Available=obj.reportTitleSettings[0].override;
      this.CustomReportObj.Wrd_AvailableHigher=obj.reportTitleSettings[1].override;
      this.CustomReportObj.Wrd_AvailableLower=obj.reportTitleSettings[2].override;
      this.CustomReportObj.Wrd_RateNotAvailable=obj.reportTitleSettings[3].override;
      this.CustomReportObj.Wrd_HotelNotAvailable=obj.reportTitleSettings[4].override;
      this.CustomReportObj.Wrd_AvailableABR=obj.reportTitleSettings[0].overrideAbr;
      this.CustomReportObj.Wrd_AvailableHigherABR=obj.reportTitleSettings[1].overrideAbr;
      this.CustomReportObj.Wrd_AvailableLowerABR=obj.reportTitleSettings[2].overrideAbr;
      this.CustomReportObj.Wrd_RateNotAvailableABR=obj.reportTitleSettings[3].overrideAbr;
      this.CustomReportObj.Wrd_HotelNotAvailableABR=obj.reportTitleSettings[4].overrideAbr;
    }
  }

  LoadPageDetails(){
    let t = this;
    t.rvService.getCustomReportListByCustomerID().subscribe(response => {
      let result = response.json();
      t.availableReportConfigurations = result;
      if(t.selectedReportConfig && t.selectedReportConfig.ReportID && t.availableReportConfigurations) {
        for(let ctr=0; ctr<t.availableReportConfigurations.length; ctr++) {
          let config = t.availableReportConfigurations[ctr];
          config.isSelected = false;
          if(config.ReportID==t.selectedReportConfig.ReportID) {
            config.isSelected = true;
          }
          t.setSeasonDisplayDates(config, 1);
          t.setSeasonDisplayDates(config, 2);
          t.setSeasonDisplayDates(config, 3);
          t.setSeasonDisplayDates(config, 4);
          t.setSeasonDisplayDates(config, 5);
          t.setSeasonDisplayDates(config, 6);
        }
      }
      for(let ctr=0; t.availableReportConfigurations && ctr<t.availableReportConfigurations.length; ctr++) {
        let config = t.availableReportConfigurations[ctr];
        config.textContent = config.Name;
        let settings = JSON.parse(config.SettingsJSON);
        config.gds = t.defaultsService.GetGDSCode(settings.Report['@GDS']);

        let report = settings.Report;
        let outputFieldCustomizationData = report.DataElements.DataElement.map(a => {
          let javascriptId = t.defaultsService.GetJavascriptIdFromFieldName(a['@ID']);
          let b = {
            id: a['@ID'],
            javascriptId: javascriptId,
            override: a['@Override'],
            active: a['@Active']==='true'?true:false
          };
          return b;
        });

        let reportTitleSettings = report.StatusCodes.StatusCode.map(a => {
          let b = {
            id: t.defaultsService.GetCustomReportTitleStatus(a['@ID']),
            override: a['@Override'],
            overrideAbr: a['@OverrideAbr']
          };
          return b;
        });
        config.outputFieldCustomizationData = {
          data: outputFieldCustomizationData,
          total: outputFieldCustomizationData.length
        };
        config.reportTitleSettings = reportTitleSettings;
      }

      //get the data to populate the report grid, but make sure the gds code list has returned
      t.gdsCodeService.getGDSCodeList(list => {
        t.checkForSelectedReportConfig();
      });
    });
  }

  checkForSelectedReportConfig() {
    if(this.selectedReportConfig) {
      this.changeGDSCode();
    } else {
      window.setTimeout(this.checkForSelectedReportConfig, 0);
    }

  }
}
